// ===== Interfaces =====

import {
    ICartItem,
}                                   from '../interfaces/ICartItem';
import {
    ICheckoutPromotionPreview,
    ICheckoutPromotionReviewResult,
}                                   from '../interfaces/ICheckoutPromotionReview';

interface IResolveCheckoutPromotionReviewParams {
    cartItems: ICartItem[];
    preview?: ICheckoutPromotionPreview;
    validate: (code: string) => Promise<boolean>;
}

/** Rechecks previewed and saved offers before review without mutating the input cart. */
export default async function resolveCheckoutPromotionReview({
    cartItems,
    preview,
    validate,
}: IResolveCheckoutPromotionReviewParams): Promise<ICheckoutPromotionReviewResult> {
    const proposedCart = cartItems.map((item) => (
        preview && item.productId === preview.productId
            ? { ...item, saleNegotiationPriceId: preview.priceId }
            : { ...item }
    ));
    const priceIds = Array.from(new Set(proposedCart.map((item) => item.saleNegotiationPriceId)
        .filter((priceId): priceId is string => !!priceId)));
    const eligibility = new Map<string, boolean>();
    await Promise.all(priceIds.map(async (priceId) => {
        const code = preview && preview.priceId === priceId ? preview.code : priceId;
        eligibility.set(priceId, await validate(code));
    }));
    let promotionRemoved = false;
    const resolvedCart = proposedCart.map((item) => {
        if (!item.saleNegotiationPriceId || eligibility.get(item.saleNegotiationPriceId)) return item;
        promotionRemoved = true;
        const regularItem = { ...item };
        delete regularItem.saleNegotiationPriceId;
        return regularItem;
    });
    return { cartItems: resolvedCart, promotionRemoved };
}
